import React from 'react';

import { Alert, Button, Stack } from '@mui/material';

import { longChatHardText, longChatSoftText } from '../chat/threadLength';

import type { LongChatNoticeState } from './longChat';

interface LongChatNoticeProps {
  state: LongChatNoticeState;
  onNotNow: () => void;
  onStartNewChat: () => void;
}

/**
 * Level 1 (1M chars): a blue info notice the reader can put off until tomorrow.
 * Level 2 (2M chars): an amber warning that stays. The composer stays usable at both levels.
 */
export default function LongChatNotice({ state, onNotNow, onStartNewChat }: LongChatNoticeProps) {
  if (state.level === 0) {
    return null;
  }
  const startNewChat = (
    <Button onClick={onStartNewChat} size="small" sx={{ flexShrink: 0, whiteSpace: 'nowrap' }} variant="contained">
      New chat
    </Button>
  );
  if (state.level === 2) {
    return (
      <Alert action={startNewChat} data-testid="long-chat-hard" severity="warning" sx={{ alignItems: 'center', mb: 1 }}>
        {longChatHardText()}
      </Alert>
    );
  }
  return (
    <Alert
      action={
        <Stack direction="row" spacing={0.5}>
          <Button onClick={onNotNow} size="small">
            Not now
          </Button>
          {startNewChat}
        </Stack>
      }
      data-testid="long-chat-soft"
      severity="info"
      sx={{ alignItems: 'center', mb: 1 }}
    >
      {longChatSoftText()}
    </Alert>
  );
}
